export default "__VITE_ASSET__2f426009__"